/* eslint-disable */
export default options => target => {
	_.extend(target.prototype, options);
};